// extracted by mini-css-extract-plugin
module.exports = {"count":"styles_count__3xIJZ","btn":"styles_btn__EFmhg"};